import { application } from "../application"

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import Ph24NewNavbarController from "./ph24_new_navbar_controller"
application.register("ph24-new-navbar", Ph24NewNavbarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import FaqToggleController from "../shared_controllers/faq_toggle_controller"
application.register("faq-toggle", FaqToggleController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import TableOfContentsController from "./table_of_contents_controller"
application.register("table-of-contents", TableOfContentsController)

import ScrollToSectionController from "./scroll_to_section_controller"
application.register("scroll-to-section", ScrollToSectionController)

import ImageCarouselController from "./image_carousel_controller"
application.register("image-carousel", ImageCarouselController)

import ExpandableCardController from "./expandable_card_controller"
application.register("expandable-card", ExpandableCardController)

import GermanyMapController from "./germany_map_controller"
application.register("germany-map", GermanyMapController)

import ProductCardController from "./product_card_controller"
application.register("product-card", ProductCardController)

import GridCarouselController from "./grid_carousel_controller"
application.register("grid-carousel", GridCarouselController)

import ImageModalController from "./image_modal_controller"
application.register("image-modal", ImageModalController)

import GalleryCarouselController from "./gallery_carousel_controller"
application.register("gallery-carousel", GalleryCarouselController)

import RadioButtonController from "../pflegegrad_rechner_controllers/radio_button_controller"
application.register("radio-button", RadioButtonController);

import QuestionFormController from "../pflegegrad_rechner_controllers/question_form_controller";
application.register("question-form", QuestionFormController);

import TreppenliftCalculatorController from "./treppenlift_calculator_controller"
application.register("treppenlift-calculator", TreppenliftCalculatorController)

import BadumbauCalculatorController from "./badumbau_calculator_controller"
application.register("badumbau-calculator", BadumbauCalculatorController)

// Floating TOC Controller
import FloatingTocController from "./floating_toc_controller"
application.register("floating-toc", FloatingTocController)

// Mobile TOC Controller
import MobileTocController from "./mobile_toc_controller"
application.register("mobile-toc", MobileTocController)

// Job Carousel Controller
import JobCarouselController from "./job_carousel_controller"
application.register("job-carousel", JobCarouselController)

// Lead Funnel Controllers

import LeadFunnelController from "../lead_funnel_controllers/lead_funnel_controller"
application.register("lead-funnel", LeadFunnelController)

import CrossSellController from "../lead_funnel_controllers/cross_sell_controller"
application.register("cross-sell", CrossSellController)

import PartnerRegistrationFormController from "./partner_registration_form_controller"
application.register("partner-registration-form", PartnerRegistrationFormController)

import LeadMagnetFormController from "./lead_magnet_form_controller"
application.register("lead-magnet-form", LeadMagnetFormController)

import NewsletterExitIntentController from "./newsletter_exit_intent_controller"
application.register("newsletter-exit-intent", NewsletterExitIntentController)

import DownloadsPageController from "./downloads_page_controller"
application.register("downloads-page", DownloadsPageController)

import VerticalTabsController from "./vertical_tabs_controller"
application.register("vertical-tabs", VerticalTabsController)

import LogoMarqueeController from "./logo_marquee_controller"
application.register("logo-marquee", LogoMarqueeController)

// Chart Controller (for pie charts, bar charts, etc.)
import ChartController from "./chart_controller"
application.register("chart", ChartController)

// Scatter Plot Controller
import ScatterPlotController from "./scatter_plot_controller"
application.register("scatter-plot", ScatterPlotController)


// Shared Controllers

import GoogletagController from "../shared_controllers/googletag_controller"
application.register("googletag", GoogletagController)

import FloatingLabelInputController from "../shared_controllers/floating_label_input_controller"
application.register("floating-label-input", FloatingLabelInputController)

import AutoSubmitController from "../shared_controllers/auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import CategoryFilterController from "./category_filter_controller"
application.register("category-filter", CategoryFilterController)

import PrintController from "./print_controller";
application.register("print", PrintController);

import ArticlesLoadMoreController from "./articles_load_more_controller"
application.register("articles-load-more", ArticlesLoadMoreController)

// Chart Download Controller
import ChartDownloadController from "../chart_download_controller"
application.register("chart-download", ChartDownloadController)
import ChartShareController from "./chart_share_controller"
application.register("chart-share", ChartShareController)

// Survey Logic Controller (for partner surveys)
import SurveyLogicController from "../survey_logic_controller"
application.register("survey-logic", SurveyLogicController)

// Star Rating Controller (for customer review form)
import StarRatingController from "../shared_controllers/star_rating_controller"
application.register("star-rating", StarRatingController)
